var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "关联固件",
        visible: _vm.associatedDialogVisible,
        width: "940px",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.associatedDialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, inline: true } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "固件名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入固件名称", clearable: "" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "固件Key" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入固件Key", clearable: "" },
                    model: {
                      value: _vm.form.componentInfoId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "componentInfoId", $$v)
                      },
                      expression: "form.componentInfoId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "固件类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.form.componentType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "componentType", $$v)
                        },
                        expression: "form.componentType",
                      },
                    },
                    _vm._l(_vm.firmwareTypeOptions, function (item) {
                      return _c("el-option", {
                        key: item.type,
                        attrs: { label: item.name, value: item.type },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "14" },
                  on: { click: _vm.queryAssociatedFirmwareList },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#F5F6F7" },
            size: "medium",
          },
        },
        [
          _c("el-table-column", { attrs: { prop: "name", label: "固件名称" } }),
          _c("el-table-column", { attrs: { prop: "id", label: "固件Key" } }),
          _c("el-table-column", {
            attrs: { prop: "componentTypeName", label: "固件类型" },
          }),
          _c("el-table-column", {
            attrs: { prop: "customNumber", label: "自定义编号" },
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "备注说明" },
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "operate" },
                        on: {
                          click: function ($event) {
                            return _vm.jumpDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          size: "operate",
                          disabled: _vm.choosing,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleChoice(scope.row)
                          },
                        },
                      },
                      [_vm._v("选择")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-sizes": [10, 20, 30, 40],
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }